import { DropdownMenu, DropdownMenuContent, DropdownMenuItem } from '@monksflow/monks-ui';
import { PencilIcon, Trash2Icon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { RowActionsTrigger } from '@/shared/ui/data-table';

interface RowMenuProps {
  onEdit: () => void;
  onDelete: () => void;
  deleteDisabled?: boolean;
}

export const RowMenu = ({ onEdit, onDelete, deleteDisabled }: RowMenuProps) => {
  const { t } = useTranslation('admin');

  return (
    <DropdownMenu>
      {/* Deliberately the page's own label rather than the `admin.rowMenu.rowActions` that the
          sibling ExternalTools kebab uses, even though the menu items below come from that same
          block. The catalog panel's tests address this trigger by "More actions". */}
      <RowActionsTrigger label={t('admin.mcpCatalogPage.moreActions')} />
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={onEdit}>
          <PencilIcon />
          {t('admin.rowMenu.edit')}
        </DropdownMenuItem>
        <DropdownMenuItem variant="destructive" disabled={deleteDisabled} onSelect={onDelete}>
          <Trash2Icon />
          {t('admin.rowMenu.delete')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
